import innerImage1 from '../../../img/cancers-we-treat/cc-large.png';

const CANCER_CARE_DATA = {
    sections: [
        {
            imageUrl: innerImage1,
            sectionHeader1: "Bladder Cancer",
            sectionCopy1: "Bladder cancer doesn’t always have symptoms but when symptoms occur, they include changes in color of urine, blood, pain when urinating or back or pelvic pain. Bladder cancer affects men more than women, but it still quite common in general. It’s the fourth most common cancer in men and ninth among women in the United States. Our urologist will perform blood and imaging tests to determine the type of cancer and offer the appropriate treatment options.",
            sectionId1: "bladder-cancer",
            sectionHeader2: "Prostate Cancer",
            sectionCopy2: "There are various types of prostate cancer that affect men. Prostate cancer is most common in men over age 65 and those who are obese are at a higher risk. Symptoms can include slow or decreased urine flow, blood in urine or semen, pain in the lower pack or pelvis or erectile dysfunction. The first diagnostic step is to perform blood and diagnostic tests to determine the stage and grade of cancer. Treatment options depend on the stage and include minimally invasive surgery using the da Vinci robotic method and/or radiation therapy, and sometimes just the wait and see approach when cancer is slow growing.",
            sectionId2: "prostate-cancer",
            id: 1
        },
        {
            imageUrl: "",
            sectionHeader1: "Kidney Cancer",
            sectionCopy1: "The most common form of kidney cancer is renal cell carcinoma. Kidney cancer oftentimes goes undetected and is found incidentally. If symptoms are present, they are typically blood in the urine, flank pain, fatigue or weight loss. Our urologist will perform diagnostic tests including a CT scan or MRI to determine grade or stage. The best treatment option is usually surgery which can be minimally invasive surgery using the da Vinci robotic used for a partial nephrectomy (or kidney removal) or open surgery for the simple or radical nephrectomy which removes the whole kidney. Other non-surgical treatments or therapies may be options for kidney cancer.",
            sectionId1: "kidney-cancer",
            sectionHeader2: "Testicular Cancer",
            sectionCopy2: "Testicular cancer is a cancer and most commonly affects males between the ages to 15 to 34. The most common symptom is a lump or enlargement in a testicle but can also include a feeling of heaviness or pain in the scrotum or a dull ache in the groin or abdomen. Our urologist will perform a CT scan or MRI diagnostic test to determine grade or stage. The best treatment option is usually surgery to remove the affected testicle or lymph nodes. Additional treatment may be chemotherapy or radiation therapy.",
            sectionId2: "testicular-cancer",
            id: 2
        }
    ],
    buttons: [
        {
            id: 1,
            buttonCopy: "Bladder Cancer",
            buttonLink: "#bladder-cancer"
        },
        {
            id: 2,
            buttonCopy: "Prostate Cancer",
            buttonLink: "#prostate-cancer"
        },
        {
            id: 3,
            buttonCopy: "Kidney Cancer",
            buttonLink: "#kidney-cancer"
        },
        {
            id: 4,
            buttonCopy: "Testicular Cancer",
            buttonLink: "#testicular-cancer"
        }
    ]
}

export default CANCER_CARE_DATA;
